﻿import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Fetching from "@/components/Fetching/Fetching";

import InventoryTableProduct from "./InventoryTableProduct";
import InventoryTableDetail from "./InventoryTableDetail";

const InventoryTable = ({ base }) => {
	const navigate = useNavigate();
	const { inventories, isFetching } = useSelector((state) => state.inventory);

	if (isFetching) {
		return (
			<tbody>
				<tr>
					<td colSpan={7}>
						<Fetching />
					</td>
				</tr>
			</tbody>
		);
	}

	const handleShowMovements = (inventory) => {
		if (inventory.CODIGO_PRODUCTO.includes("G")) {
			navigate("/inventario/movimientos/" + inventory.CODIGO_PRODUCTO + "/" + inventory.INVENTORY_ID);
			return;
		}

		if (Object.prototype.hasOwnProperty.call(inventory, "ID_INVENTARIO")) {
			navigate("/inventario/movimientos/" + inventory.CODIGO_PRODUCTO + "/" + inventory.IDENTIFICADOR);
			return;
		}

		navigate("/inventario/movimientos/" + inventory.CODIGO_PRODUCTO);
	};

	return (
		<tbody>
			{inventories.map((inventory, i) => {
				return [
					<InventoryTableProduct key={`product_${i}`} index={i} handleShowMovements={handleShowMovements} />,
					<InventoryTableDetail key={`detail_${i}`} index={i} base={base} handleShowMovements={handleShowMovements} />,
				];
			})}
		</tbody>
	);
};

export default InventoryTable;
